/* tslint:disable */
/* eslint-disable */
export enum WorkItemRelationNamesEnum {
  CreatedByUser = 'createdByUser',
  ModifiedByUser = 'modifiedByUser',
  Containertype = 'containertype',
  Documents = 'documents',
  ItemCompatibilities = 'itemCompatibilities',
  ItemRestrictions = 'itemRestrictions',
  Prices = 'prices',
  Producer = 'producer',
  Productgroup = 'productgroup',
  Serialnumbers = 'serialnumbers',
  Unit = 'unit',
  Vendor = 'vendor',
  HeightUnit = 'heightUnit',
  LengthUnit = 'lengthUnit',
  WidthUnit = 'widthUnit',
  DiameterUnit = 'diameterUnit',
  WeightUnit = 'weightUnit',
  None = 'none'
}
